export class GerenciamentoPermissoesModels {

        constructor(
                public descricaoItemMenu?: string,
                public url?: string,
                public liberarAcesso?: Boolean
        ) {

        }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/gerenciamento-permissoes.model.ts